import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description: 'Rozliczane miesięcznie. Roczny to okres zobowiązania, a nie częstotliwość rozliczeń.',
      options: {
        [SubscriptionTerm.Monthly]: 'Okres miesięczny',
        [SubscriptionTerm.Annual]: 'Okres roczny',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Model cenowy',
          title: 'Skala cenowa oparta na wynikach',
        },
        [PlanTab.legacy]: {
          name: 'Legacy',
          title: 'Plany',
        },
      },
    },
    add_ons: {
      title: 'Zostań Pro dzięki naszym dodatkom do Planu Essential',
      description: 'Przyciągnij nowych gości i zwiększ powroty dzięki tym rozwiązaniom.',
    },
  },
  labels: {
    recommended: 'Zalecane',
    basket: 'Koszyk: <strong>{{amount}}</strong> miesięcznie',
  },
  buttons: {
    review_and_subscribe: 'Przejrzyj i subskrybuj',
    cancel: 'Anuluj',
    basket: 'Wróć do koszyka',
    subscribe: 'Subskrybuj',
    update_subscription: 'Zaktualizuj subskrypcję',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_save_contract: 'Nie udało się zapisać umowy o usługę',
    failed_to_create_subscription: 'Nie udało się utworzyć subskrypcji',
    subscription_created: 'Subskrypcja została pomyślnie utworzona',
    subscription_updated: 'Subskrypcja została pomyślnie zaktualizowana',
  },
};
